import BaseModel from './BaseModel';
import { Utils } from '../services';

/** Class representing an event. */
class Event extends BaseModel {
    static TYPE_MOVIE       = 'movie';
    static TYPE_DRAMA       = 'drama';
    static TYPE_MUSIC_GROUP = 'music_group';
    static TYPE_EXHIBITION  = 'exhibition';
    static TYPE_SERVICE     = 'service';

    static sectionIdsFromValue(sections) {
        if (!Array.isArray(sections)) {
            return [];
        }
        return sections.map((section) => {
            if (typeof section === 'string' || typeof section === 'number') {
                return String(section);
            }
            return section?.id || section?._id || null;
        }).filter(Boolean);
    }

    /**
     * Prepare this object for update.
     * This is used to "normalize", if needed, some properties
     * before to send them.
     *
     * return{BaseModel}
     */
    prepareForUpdate() {
        const prepared = super.prepareForUpdate();
        for (let i = 1; i <= 6; i += 1) {
            const key = `free_text_${i}`;
            Utils.cleanTranslatableProperty(prepared, key);
        }
        if (prepared.title && typeof prepared.title === 'object') {
            Object.keys(prepared.title).forEach((t) => {
                if (typeof prepared.title[t] === 'string') {
                    prepared.title[t] = prepared.title[t].trim();
                }
            });
        }

        if ('year' in prepared) {
            if (!prepared.year)
                prepared.year = null;
        }

        prepared.sections = Event.sectionIdsFromValue(prepared.sections);

        return prepared;
    }

    static getTypeIcon(type) {
        switch (type) {
            case Event.TYPE_MOVIE:
                return 'film';
            case Event.TYPE_DRAMA:
                return 'theater-masks';
            case Event.TYPE_MUSIC_GROUP:
                return 'music';
            case Event.TYPE_SERVICE:
                return 'gift';
            case Event.TYPE_EXHIBITION:
                return 'image';
            default:
                return 'circle';
        }
    }
}

export default Event;
